//src/command/utils/sembols.js
 
import { Rectangle, PolyLine, Circle, Line, PolarLine, Arc, Text } from "./utils"


const layers = {
  0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
  kirmizi: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
  yesil: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65280 },
  mavi: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 255 },
  sari: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16776960 },
  magenta: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16711935 },
  cyan: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65535 },
  gray: { name: 'test', frozen: false, visible: true, colorIndex: 8, color: 12632256 },
};
const kirmizi = layers.kirmizi
const mavi = layers.mavi
const yesil = layers.yesil
const gray = layers.gray

const op_gray = {
  color: gray.color,
  colorIndex: gray.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const op_yesil = {
  color: yesil.color,
  colorIndex: yesil.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const Scl = 1// 0.75
const rowHeight = 50 * Scl
 
const textHeight=12*Scl

export const createTopraklamaHesab = (data) => {
    // ✅ SIMPLE SUPPLY POINT SAFE DESTRUCTURING
  const {
    soilResistivity = 100,  // Default values for safe calculation
    area = 10,
    strakeLength = 5,
    stripLength = 20,
    ul = 1,
    strakeCount = 2
  } = data || {}; // Safe destructuring with fallback
   let soilResText=`=${soilResistivity} Ω`
 let areaText=`=${area.toFixed(2)} m²`
 let strakeLengthText=`=${strakeLength.toFixed(1)} m`
 let stripLengthText=`=${stripLength.toFixed(2)} m`
 let strakeCountText=`=${strakeCount.toFixed(0)} `
 let d_Text=`=2x√(${area.toFixed(2)}/3.14)  `
 let d_result =  2*Math.sqrt(area/Math.PI )
 let d_result_Text=`=${d_result.toFixed(2)}Ω  `

 let ry_text=`=${soilResistivity}/(2x${d_result.toFixed(2)})+${soilResistivity}/${stripLength.toFixed(2)}  `
 let ry_result= soilResistivity / (2*d_result)+soilResistivity/stripLength 
 let ry_result_Text= `=${ry_result.toFixed(2)}Ω`

 let rç_text=`=${soilResistivity}/(${strakeCount }+${strakeLength})  `
 let rç_result= soilResistivity / ((strakeCount)+strakeLength)
 let rç_result_Text= `=${rç_result.toFixed(2)}Ω`

 let re_text=`=(${ry_result.toFixed(2)}x${rç_result.toFixed(2)})/(${ry_result.toFixed(2) }+${rç_result.toFixed(2)})  `
 let re_result= (ry_result*rç_result) / (ry_result+rç_result )
 let re_result_Text= `=${re_result.toFixed(2)}Ω`
 
 let result_Text= `${re_result.toFixed(2)}Ω<166.67Ω  `
    let k = 0 // bu sabit en alttaki summer kısmının yüksekliğpini ayarlamada kullanılıyor. 
    const rows = [
  ["β- Toprak Özgün Direnci  ", soilResText , "D-EşDeğer Çap (m)"               ],
  ["L- Şerit Boyu            ", stripLengthText,  "Ry-Yatay Topraklama Direnci (Ω)" ],
  ["Iç-Çubuk Elektrot Boyu   ", strakeLengthText ,  "Rç-Dikey Toprakalama Direnci (Ω)"],
  ["A- İnşaat Alanı          ", areaText, "Re-Eş değer Direnç (Ω)"          ],
  ["Es-Elektrot Sayısı       ", strakeCountText  ,  "EKA-Eşik Kaçak Akım 300mA"  ],
  /*
  ["Es-Elektrot Sayısı       ", "=4"  ,  "Kaçak Akım Koruma Rölesi 300mA"  ], */
  [ "D =2x√(A/П) ",   d_Text ,  d_result_Text  ],
  [ "Ry=β/(2xD)+β/L",   ry_text ,  ry_result_Text  ],
  [ "Rç=β/(Es+Iç)",    rç_text ,  rç_result_Text  ],
  [ "Re=(RyxRç))/(Ry+Rç)",   re_text ,  re_result_Text  ],
  [ "Ra=KaçakAkımKorumaRölesi ve TT sistem UL sine göre belirlenen eşik direnç.",   " " ,  " "  ],
  [ "Ra=UL/EKA",   "=50V /300mA" ,  "=166.67Ω"  ],
  [ result_Text,   "OLDUĞU İÇİN UYGUNDUR" ,  " "  ],
];

 let X=0
 let Y=0
 let rowHeight=20*Scl
  let rowY=  rowHeight*rows.length
  let result = []



 
  const gap = 10 * Scl 
  let headerHeight = 50 * Scl
 
  let docWidth = 550 * Scl
const headerTextWidth=235*Scl
let  text = {
      text: "TOPRAKLAMA HESABI",
      x: docWidth/2-headerTextWidth/2   ,
      y: rowHeight*rows.length+ headerHeight-20 * Scl   ,
      textHeight:22.5 * Scl,
      id: `title_text_header_ToprakalamaHesap`
    };
    text.handle = text.id;
    result.push(Text(text.x, text.y , text, 0, op_gray));

/*    result.push(PolarLine(X, Y+5*Scl, 0,  0*Scl, op_gray)) // Bu satır Tüm çizimi aşağı kaydırmak için
   result.push(PolarLine(X, Y+300*Scl, 0,  100*Scl, op_gray)) // Bu satır Tüm çizimi aşağı kaydırmak için
  */
   const  vertices=[
      { x:0,y:-10 * Scl ,z:0 },
      { x:0,y:headerHeight+rowHeight*rows.length+10 * Scl ,z:0 },
      { x:docWidth,y:headerHeight+rowHeight*rows.length+10 * Scl ,z:0 },
      { x:docWidth,y:-10 * Scl ,z:0 },
    ]
    op_gray.shape=true
     result.push(PolyLine(0,0,vertices,op_gray))
    result.push(PolarLine(0,rowHeight*rows.length +10 * Scl  , 0,docWidth, op_gray));




 
const col2X = 145 * Scl; // ikinci sütunun X konumu
const col3X = 320 * Scl; // ikinci sütunun X konumu

rows.forEach(([label, value,desc]) => {
  let text1 = { text: label, x: 10 * Scl, y: rowY, textHeight: textHeight };
  text1.handle = generateStableId(text1);
  result.push(Text(text1.x, text1.y, text1, 0, op_gray));

  let text2 = { text: value, x: col2X, y: rowY, textHeight: textHeight };
  text2.handle = generateStableId(text2);
  result.push(Text(text2.x, text2.y, text2, 0, op_gray));

  let text3 = { text: desc, x: col3X, y: rowY, textHeight: textHeight };
  text3.handle = generateStableId(text3);
  result.push(Text(text3.x, text3.y, text3, 0, op_gray));

  rowY -= rowHeight;
  headerHeight+=rowHeight
});

  headerHeight+=rowHeight  

  rowY -= rowHeight; 


  return { result: result, width: docWidth , height: headerHeight    }; 

};

function generateStableId(element) {
  let faktor = "0"
  if (element.handFak) { faktor = element.handFak }
  return `text-${element.text}-${element.x}-${element.y}-${element.textHeight}-${faktor}`;
}













